export class CorporationActiveDevice {
  constructor(item) {
    this.count = item.realActiveDevices;
    this.corporateCode = item.corporateCode;
  }
  
  corporateCode: string;
  count: number;
}
